import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable";
import { db, balaCollection, userDataCollection } from "@/firebase";
import { Module } from "@/store/enums.ts";
import { updateStudentScoring } from "@/service/DashboardBackend";

@Component
export default class WritingTask2Understanding extends Vue {
  dialog = false;
  valid = true;
  // paragraphQuestion = "Ask three questions about the video you just saw.";
  // paragraphs = ["", "", ""];

  private _questions: any;

  constructor() {
    super();
    this._questions = this.$store.getters.balaWQuestions.writingTask2;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balaWQuestions.writingTask2;
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item: any) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  private isComplete() {
    return this.$store.getters.balaSections[8].sectionProgress.Question == 100;
  }

  submit() {
    if (this.$store.getters.balaSections[8].sectionProgress.Question != 100) {
      var thisUser = this.$store.getters.user;
      var uid = thisUser.data.uid;

      let timepoint = this.$store.getters.balaTimepointStr;
      let data = this.getData();

      updateStudentScoring();

      // Store question answers
      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(timepoint)
        .collection("responses")
        .doc("writingTask2")
        .set(
          {
            QuestionsAnswers: data
          },
          { merge: true }
        )
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(timepoint)
            .update({
              "completionStatus.writingTask2.question": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {});

      // Update progress in $store
      this.$store.dispatch("updateBalaProgress", {
        section: "Writing Task 2",
        subsection: "Questions"
      });
    }
    this.$router.push({ name: "balaWT2Planning" });
  }

  private stateLoaded() {
    return this.$store.getters.balaWQuestions.writingTask2Loaded;
  }

  main() {
    return (
      <Card title="Your turn to ask questions" mod={Module.BALA}>
        <v-form ref="form" v-model={this.valid} slot="mainContent">
          <v-list class="overflow-y-auto" max-height="300">
            {this._questions.map((item: any, i: number) => (
              <span>
                <v-toolbar flat>{item.question}</v-toolbar>
                {item.answer.map((_item: any, _i: number) => (
                  <v-list-item>
                    <v-textarea
                      v-model={item.answer[_i]}
                      counter
                      disabled={this.isComplete()}
                      label={`Question ${_i + 1}`}
                      rules={[
                        (v: any) =>
                          (v.length > 0 && v.length < 300) ||
                          "Max 300 characters"
                      ]}
                    ></v-textarea>
                  </v-list-item>
                ))}
              </span>
            ))}
          </v-list>
        </v-form>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn disabled={!this.valid} color="secondary" onClick={this.submit}>
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={0}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    return this.stateLoaded() ? this.main() : "";
  }
}

const component = WritingTask2Understanding;
